import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ThemeProvider } from '@mui/styles';
import { createTheme, StyledEngineProvider } from '@mui/material';
import { Theme } from '@emotion/react';

// Hooks and services
import store from './redux/store';
import { NotifyProvider } from './hooks/context/NotifyMessageContext';
import { TimeModeProvider } from './hooks/context/TimeModeContext';

// Style
import './App.css';

// Components
import Layout from './components/base/layout/layout';
import { NotificationMessage } from './components/common/NotifyMessage';
import MobileLayout from './components/base/layout/MobileLayout';
import SignupForm from './components/pages/authenticate/register';
import ThankYou from './components/pages/authenticate/thankYou';
import AppUserPasswordReset from './components/pages/account/appUserPasswordReset';
import AppUserPasswordResetOk from './components/pages/account/appUserPasswordResetOk';
import AppUserPasswordResetAnonymous from './components/pages/account/appUserPasswordResetAnonymous';
import AppUserPasswordResetAnonymousSent from './components/pages/account/appUserPasswordResetAnonymousSent';

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

const theme = createTheme();

export function App() {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <BrowserRouter>
              <NotifyProvider>
                <TimeModeProvider>
                  <Routes>
                    <Route path='mobile/*' element={<MobileLayout />} />
                    <Route path='/register' element={<SignupForm />} />
                    <Route path='/password-reset' element={<AppUserPasswordResetAnonymous />} />
                    <Route path='/password-reset-sent' element={<AppUserPasswordResetAnonymousSent />} />
                    <Route path='/password-reset/:id/:code' element={<AppUserPasswordReset />} />
                    <Route path='/password-reset-ok' element={<AppUserPasswordResetOk />} />
                    <Route path='/thank-you-for-registering' element={<ThankYou />} />
                    <Route path='*' element={<Layout />} />
                  </Routes>
                </TimeModeProvider>
                <NotificationMessage />
              </NotifyProvider>
            </BrowserRouter>
          </LocalizationProvider>
        </Provider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
